var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { ButtonContainer, Container, Image, ImageContainer, UploadContainer, } from "./AvatarUpload.styles";
import { useField } from "formik";
import EditUpload from "../assets/AvatarUpload/EditAvatar";
import { FileUpload } from "../FileUpload";
export var AvatarUpload = function (_a) {
    var setFieldValue = _a.setFieldValue, props = __rest(_a, ["setFieldValue"]);
    var _b = __read(useField(props), 1), field = _b[0]; // add meta for error handling
    var _c = __read(useState(false), 2), editOpen = _c[0], setEditOpen = _c[1];
    var placeFieldValue = function (name, value, shouldValidate) {
        if (shouldValidate === void 0) { shouldValidate = true; }
        //extract first value from map
        var file = value.values().next().value;
        if (setFieldValue)
            setFieldValue(name, file, shouldValidate);
        //hide the file upload
        setEditOpen(false);
    };
    return (React.createElement(Container, null,
        React.createElement(ImageContainer, { hasImg: !!field.value },
            !!field.value ? (typeof field.value === "string" ? (React.createElement(Image, { src: field.value })) : (React.createElement(Image, { src: URL.createObjectURL(field.value) }))) : null,
            React.createElement(ButtonContainer, { type: "button", onClick: function () {
                    setEditOpen(function (oldOpen) { return !oldOpen; });
                } },
                React.createElement(EditUpload, { width: "35px", height: "35px" }))),
        React.createElement(UploadContainer, { hidden: !editOpen },
            React.createElement(FileUpload, __assign({}, props, { maxNumberOfFiles: 1, allowedFileTypes: "image/*", setFieldValue: placeFieldValue })))));
};
//# sourceMappingURL=AvatarUpload.js.map